import request from '@/utils/ajax'

export function getTelegramConfigList(params) {
    return request({
        url: '/wx/manage/tgBotConfig/list',
        method: 'get',
        params
    })
}

export function getTelegramCandidateChats(id, params) {
    return request({
        url: `/wx/manage/tgBotConfig/${id}/candidateChats`,
        method: 'get',
        params
    })
}

export function getTelegramCandidateMembers(id, chatId, params) {
    return request({
        url: `/wx/manage/tgBotConfig/${id}/candidateChats/${chatId}/members`,
        method: 'get',
        params
    })
}

export function saveTelegramConfig(data) {
    return request({
        url: '/wx/manage/tgBotConfig/save',
        method: 'post',
        data: data
    })
}

export function editTelegramConfig(data) {
    return request({
        url: '/wx/manage/tgBotConfig/update',
        method: 'put',
        data: data
    })
}

export function deleteTelegramConfig(data) {
    return request({
        url: '/wx/manage/tgBotConfig/delete',
        method: 'post',
        data: data
    })
}

export function buildTelegramConfigPayload(form, editing) {
    const payload = {
        name: form.name,
        desc: form.desc,
        status: form.status,
        botRole: form.botRole
    }
    if (editing) payload.id = form.id
    if (!editing || String(form.token || '').trim()) payload.token = form.token
    return payload
}
